import { Link } from '@tanstack/react-router';
import { useAuth } from '@/auth/auth-provider';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useRuntimeConfig } from '../runtime-config-context';
import { visibleNav } from '../nav';
import { navLinkProps } from '../shell/nav-link';

/** Interim home: every area you can reach. The analytics overview takes this place in Phase 3. */
export function HomePage() {
  const { session, can, superAdmin } = useAuth();
  const { presentation } = useRuntimeConfig();
  const sections = visibleNav(presentation.navigation.items, { can, superAdmin });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Welcome back, {session?.user.fullName}</h1>
        <p className="text-sm text-muted-foreground">
          The new backoffice is being built area by area. Pages not rebuilt yet link to the current one.
        </p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {sections.map((section) => (
          <Card key={section.id}>
            <CardHeader className="flex flex-row items-center gap-2 space-y-0">
              <section.icon className="text-muted-foreground" />
              <CardTitle className="text-base">{section.label}</CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="space-y-1 text-sm">
                {section.items.map((item) => (
                  <li key={item.id}>
                    <Link {...navLinkProps(item)} className="text-primary underline-offset-4 hover:underline">
                      {item.label}
                    </Link>
                    {!item.ready && <span className="ml-2 text-xs text-muted-foreground">coming soon</span>}
                    {item.children && (
                      <ul className="mt-1 ml-3 space-y-1 border-l pl-3">
                        {item.children.map((child) => (
                          <li key={child.id}>
                            <Link {...navLinkProps(child)} className="text-primary underline-offset-4 hover:underline">
                              {child.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
